import React, { ComponentProps } from 'react'
import CenteredLoadingAnimation from './CenteredLoadingAnimation'
import { Box } from './Components'
import { User } from './icons'
import SuspenseImage from './SuspenseImage'

interface Props {
  imageUrl?: string
  alt?: string
  size?: string
  bg?: string
  rounded?: boolean
}

const Avatar: React.FC<Props & ComponentProps<typeof Box>> = ({
  imageUrl,
  alt,
  size,
  bg,
  rounded,
  css,
  ...props
}) => (
  <Box
    {...props}
    css={{
      height: size || '40px',
      width: size || '40px',
      minWidth: size || '40px',
      borderRadius: rounded ? '$10' : '50%',
      backgroundColor: bg || 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      ...css
    }}
  >
    {imageUrl ? (
      <React.Suspense fallback={<CenteredLoadingAnimation light />}>
        <SuspenseImage
          src={imageUrl}
          alt={alt}
          css={{
            height: 'inherit',
            width: 'inherit',
            objectFit: 'cover'
          }}
        />
      </React.Suspense>
    ) : (
      <User />
    )}
  </Box>
)

export default Avatar
